import styled from 'styled-components';
import { MdEdit, MdDelete } from 'react-icons/md';
import { FaEye } from 'react-icons/fa';

export const Container = styled.div``;

export const WrapperTable = styled.div`
  padding: 20px 0;
`;

export const EyeIcon = styled(FaEye).attrs({ size: '19px' })`
  color: #122d58;
  cursor: pointer;
  margin-right: 26px;
  &:hover {
    color: #0a1f3d;
  }
`;

export const EditIcon = styled(MdEdit).attrs({ size: '19px' })`
  color: #4caf50;
  cursor: pointer;
  margin-right: 26px;
  &:hover {
    color: #388e3c;
  }
`;

export const DeleteIcon = styled(MdDelete).attrs({ size: '19px' })`
  color: #f44336;
  cursor: pointer;
  margin-right: 26px;
  &:hover {
    color: #d32f2f;
  }
`;

export const Icon = styled.img`
  width: 19px;
  height: 19px;
  /* margin-right: 26px; */
`;
